export default __webpack_public_path__ + "static/media/shape2.5137596b.png";